module.exports = __webpack_public_path__ + "img/rzlogo.63ad8ea7.png";